import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useGetFleetsQuery, useResetToPhoneAuthMutation } from '../../../../api/fleet-verification';
import { FLEET_SELECTION } from '../../../../paths';
import { RootState } from '../../../../store';

const useVerifyAnotherCompany = () => {
  const [resetToPhoneAuth, { isSuccess: tokenReset }] = useResetToPhoneAuthMutation();
  const navigate = useNavigate();

  const needsTokenReset = useSelector((state: RootState) => state.session.applicantId !== null);

  useEffect(() => {
    if (needsTokenReset) {
      void resetToPhoneAuth();
    }
  }, [needsTokenReset, resetToPhoneAuth]);

  const canFetch = !needsTokenReset || tokenReset;

  const { data: fleets, isFetching } = useGetFleetsQuery(undefined, {
    skip: !canFetch,
    refetchOnMountOrArgChange: true,
  });

  const showVerifyAnotherButton = canFetch && !isFetching && (fleets?.length ?? 0) >= 2;

  const handleVerifyAnotherClick = useCallback(() => {
    navigate(FLEET_SELECTION);
  }, [navigate]);

  return { showVerifyAnotherButton, handleVerifyAnotherClick };
};

export { useVerifyAnotherCompany };
